import React from "react";
import { Routes, Route, NavLink, Navigate } from "react-router-dom";
import SettingsUsers from "./settings/SettingsUsers";
import SettingsExpenseTypes from "./settings/SettingsExpenseTypes";
import SettingsExpenseMarkets from "./settings/SettingsExpenseMarkets";

const tabs = [
  { to: "/settings/users", label: "Manage Users", testid: "settings-tab-users" },
  { to: "/settings/expense-types", label: "Expense Types", testid: "settings-tab-types" },
  { to: "/settings/expense-markets", label: "Expense Markets", testid: "settings-tab-markets" },
];

export default function SettingsPage() {
  return (
    <div className="p-6 sm:p-10 max-w-[1400px] mx-auto animate-fade-in-up" data-testid="settings-page">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-taupe-500 mb-2">Admin</div>
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tighter text-espresso-900">Settings</h1>
        <p className="text-taupe-600 mt-2 text-sm">Manage team, expense types & delivery markets.</p>
      </div>

      <div className="flex flex-wrap gap-2 mb-6 border-b border-taupe-200">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            data-testid={t.testid}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-semibold border-b-2 -mb-px transition-colors ${
                isActive
                  ? "border-espresso-800 text-espresso-900"
                  : "border-transparent text-taupe-600 hover:text-espresso-800"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <Routes>
        <Route index element={<Navigate to="users" replace />} />
        <Route path="users" element={<SettingsUsers />} />
        <Route path="expense-types" element={<SettingsExpenseTypes />} />
        <Route path="expense-markets" element={<SettingsExpenseMarkets />} />
      </Routes>
    </div>
  );
}
